var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128029(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2,.cls-3,.cls-4{fill:none;}.cls-2{opacity:0.2;}.cls-3{stroke:#6e6e6e;stroke-linejoin:round;}.cls-3,.cls-4{stroke-linecap:round;stroke-width:1.25px;}.cls-4{stroke:#ff6a10;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.08,108.84l.1-.61a2.09,2.09,0,0,0-.58-1.79l-18-18A9,9,0,0,1,13,82.72L11.71,67.43c0-.19,0-1.93,0-2.11l3.62-16.84a1,1,0,0,1,1.25-.77c2.84.77,6.87,4.94,3.9,17.3L25,73.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.52,88.8,25,80.54c-4-3.38-1.06-10.78,6.75-4.05l9.67,7.27c19.23,1.71,15.42,25.16,15.42,25.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "28.2 121.08 28.2 109.14 61.6 109.14 61.6 121.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 28.55,
    y1: 116.8,
    x2: 61.6,
    y2: 116.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 57.62,
    cy: 113.16,
    rx: 1.38,
    ry: 1.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.92,108.84l-.1-.61a2.09,2.09,0,0,1,.58-1.79l18-18a9,9,0,0,0,2.6-5.67l1.29-15.29c0-.19,0-1.93,0-2.11l-3.62-16.84a1,1,0,0,0-1.25-.77c-2.84.77-6.87,4.94-3.9,17.3L103,73.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.48,88.8,103,80.54c4-3.38,1.06-10.78-6.75-4.05l-9.67,7.27c-19.23,1.71-15.42,25.16-15.42,25.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "99.8 121.08 99.8 109.14 66.4 109.14 66.4 121.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 99.45,
    y1: 116.8,
    x2: 66.4,
    y2: 116.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 70.38,
    cy: 113.16,
    rx: 1.38,
    ry: 1.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.25,55.55S50.68,54.82,49.79,45C49.79,45,59.68,45.75,62.25,55.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.37,55.55S76.94,54.82,77.82,45C77.82,45,67.94,45.75,65.37,55.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.59,74.3s-15.66-1-16.86-14.25C45.73,60.05,59.11,61,62.59,74.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.41,74.23s15.66-1,16.86-14.25C82.27,60,68.89,61,65.41,74.23Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "62.77 89.93 62.77 40.71 65.03 40.71 65.03 89.93"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 63.86,
    cy: 30.05,
    rx: 10.84,
    ry: 10.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.25,26.8a4.68,4.68,0,1,0,0,6.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.92,
    y1: 29.02,
    x2: 63.52,
    y2: 29.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.92,
    y1: 31.19,
    x2: 63.52,
    y2: 31.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.57,
    y1: 6.4,
    x2: 63.57,
    y2: 11.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 89.26,
    y1: 13.07,
    x2: 83.94,
    y2: 19.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 103.65,
    y1: 30.29,
    x2: 96.16,
    y2: 34.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.02,
    y1: 13.07,
    x2: 43.97,
    y2: 19.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.99,
    y1: 31.58,
    x2: 32.3,
    y2: 34.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.84,
    y1: 67.9,
    x2: 62.11,
    y2: 73.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 73.92,
    y1: 67.9,
    x2: 65.64,
    y2: 73.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 55.76,
    y1: 50.95,
    x2: 61.67,
    y2: 55.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 71.44,
    y1: 50.95,
    x2: 65.54,
    y2: 55.27
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128029);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_029.a8e0fb8a2a5af7183e9d8f74fc1bfbdd.svg";
export { ForwardRef as ReactComponent };